/**
 * Maintained by Sandon.
 */
<template>
  <div
    class="sy-magic-input"
    :class="{
      'sy-magic-input--mini': this.size === 'mini',
      'fix-height': fixHeight,
      'hide': !showTags && !visible,
      'tags-expand': showTags || visible,
      'sy-magic-input--disabled': disabled
    }"
    :style="{height: fixHeight ? `${height}px` : ''}"
    @mouseenter="_mouseEnter"
    @mouseleave="_mouseLeave">
    <el-popover
      placement="bottom-start"
      :width="realPopperWidth"
      ref="popover"
      trigger="manual"
      :value="visible"
      :popper-class="`sy-magic-input__popper ${popperClass}`"
    >
      <div slot="reference" class="sy-magic-input__wrap" :class="{'sy-magic-input__wrap--fixed': fixHeight}">
        <!--多选-->
        <!--top: !showTags && !visible ? `${(this.height - 28) / 2}px` : '50%',-->
        <!--'align-top': !showTags && !visible, 'scroll': fixHeight-->
        <div
          v-if="multiple"
          class="sy-magic-input__tags"
          ref="tags"
          :style="{padding: `${padding}px 0`}">
          <scrollbar :wrap-style="{'max-height': fixHeight ? `${selectedTagsMaxHeight}px` : 'auto'}">
            <slot></slot>
          </scrollbar>

          <!--多选时的搜索框, IE9+多选不支持搜索，因为不支持placeholder，造成用户以为样式有问题-->
          <!--todo :style="{'max-width': `${width - 10}px`}"-->
          <input
            ref="multiple-filter-input"
            v-if="filterable && !isIE9"
            class="sy-magic-input__filter-input"
            type="text"
            v-model="filter"
            :placeholder="multipleFilterPlaceholder"
            :style="{'height': `${tagHeight}px`}"
            :disabled="disabled"
            @blur="_multipleFilterInputBlur"
            @focus="_multipleFilterInputFocus">
        </div>
        <!--撑开的input，及单选时的选中展示和搜索-->
        <!--<el-tooltip :disabled="!(completeText && !multiple && inputValue == text)" effect="dark" :content="completeText" placement="top-start">-->
        <el-input
          :placeholder="showedPlaceholder"
          class="sy-magic-input__input"
          ref="input"
          v-model="inputValue"
          :title="disableTitle ? '' : (completeText && !multiple && inputValue == text) ? completeText: inputValue"
          :disabled="disabled"
          :readonly="multiple || !filterable"
          :class="{ 'is-focus': visible, 'sy-magic-input__input--clear': showedClear }"
          @focus="_inputFocus"
          @blur="_inputBlur">
          <template slot="suffix" v-if="!disabled">
            <i
              v-if="showedClear"
              class="el-select__caret el-input__icon el-icon-circle-close sy-magic-input__clear"
              @click.stop="_clear">
            </i>
            <i
              :class="['el-select__caret', 'el-input__icon', 'el-icon-' + iconClass, 'sy-magic-input__expand']"
              @click="_toggleVisible">
            </i>
          </template>
        </el-input>
        <!--</el-tooltip>-->
      </div>
      <slot name="popper"></slot>
    </el-popover>
  </div>
</template>

<script>
  import i18n from './i18n'
  import {debounce} from 'lodash-es'
  import scrollbar from '../scrollbar'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'magic-input',
    components: {scrollbar},
    props: {
      // 是否多选
      multiple: {type: Boolean, default: false},
      // 是否禁用
      disabled: {type: Boolean, default: false},
      // 是否可进行搜索
      filterable: {type: Boolean, default: false},
      // 是否固定高度
      fixHeight: {type: Boolean, default: false},
      // popper是否展示
      visible: {type: Boolean, default: false},
      // 选中项展示时，最大的高度，超长会显示滚动条
      selectedTagsMaxHeight: {type: Number, default: 110},
      // 过滤搜索时，输入框的placeholder
      filterPlaceholder: {type: String, default: pageText.search},
      // placeholder
      placeholder: {type: String, default: pageText.pleaseChoose},
      // 输入框展示的文本
      text: {type: String, default: ''},
      // 输入框展示的文本的完整形式，用来hover展示
      completeText: {type: String, default: ''},
      // size大小
      size: {type: String, default: ''},
      // popper宽度
      popperWidth: {type: Number, default: 0},
      // popper的class
      popperClass: {type: String, default: ''},
      // 不需要title
      disableTitle: {type: Boolean, default: false},
      // 是否可清空（只对单选）
      clearable: {type: Boolean, default: true},
      // 是否冻结，冻结时不会监听滚动事件而调整 popper 位置
      frozen: {type: Boolean, default: false}
    },
    data () {
      return {
        isIE9: navigator.userAgent.indexOf('MSIE 9') !== -1,
        showTags: !this.fixHeight, // 选中的tags是否完整展示，为了实现fixHeight情况下的tags的展示
        filter: '',
        isInputFocus: false,
        isMultipleFilterInputFocus: false,
        inputValue: '',
        height: 32,
        tagHeight: 28, // 这是tag 加上了margin后的高度值
        popperUpdater: null, // popper的更新函数
        realPopperWidth: 0
      }
    },
    created () {
      switch (this.size) {
        case 'mini':
          this.height = 28
          this.tagHeight = 24
          break
        default:
          this.height = 32
          this.tagHeight = 28
      }

      this._updateInputValue()

      this.popperUpdater = debounce(this.updatePopper.bind(this), 60)
    },
    computed: {
      iconClass: function () {
        return this.visible ? 'arrow-up' : 'arrow-down'
      },
      showedPlaceholder: function () {
        if (!this.filterable) {
          // 无搜索
          return this.text ? '' : this.placeholder
        } else if (this.multiple) {
          // 搜索 + 多选
          return ''
        } else {
          // 搜索 + 单选
          if (!this.isInputFocus) {
            // blur时
            return this.placeholder
          } else {
            // focus时，选中值或filterPlaceholder默认值
            return this.text || this.filterPlaceholder
          }
        }
      },
      multipleFilterPlaceholder () {
        return this.isMultipleFilterInputFocus ? this.filterPlaceholder : this.placeholder
      },
      showedClear: function () {
        // 多选 || 单选 + 非clearable
        if (this.multiple || !this.clearable) {
          return  false
        }

        if (!this.filterable) {
          // 非搜索，取决于`inputValue`是否有值
          return this.inputValue
        } else {
          // 搜索，focus时是输入搜索词所以不显示clear，blur时取决于`inputValue`
          return !this.isInputFocus && this.inputValue
        }
      },
      padding: function () {
        // const tagHeight = this.size === 'mini' ? 24 : 28 // 这是tag 加上了margin后的高度值
        return (this.height - this.tagHeight - 2) / 2 // -2是因为top为1px(对应底部也留1px)
      }
    },
    watch: {
      text: function () {
        this._updateInputValue()
      },
      isInputFocus: function () {
        this._updateInputValue()
      },
      visible () {
        this.updateHeight()

        // 绑定和卸载 popperUpdater，由于scroll不冒泡，所以在捕获阶段，这样能适配局部滚动（包括页面框架）
        if (this.visible) {
          window.addEventListener('scroll', this.popperUpdater, true)
        } else {
          window.removeEventListener('scroll', this.popperUpdater, true)
        }
      },
      showTags () {
        this.updateHeight()
      },
      inputValue () {
        // 单选+搜索,用户手动输入时，输入值作为搜索条件，所以同步给filter
        if (!this.multiple && this.filterable && this.isInputFocus) {
          this.filter = this.inputValue
        }
      },
      filter: function (val) {
        // console.log('filter 改变了')
        this.$emit('filter', this.filter)
      },
      popperWidth: function () {
        this._calcRealPopperWidth()
      }
    },
    mounted () {
      this.updateHeight(true)
  
      this._calcRealPopperWidth()
    },
    methods: {
      _calcRealPopperWidth () {
        this.realPopperWidth = this.popperWidth ||
          Math.max(this.$el.getBoundingClientRect().width, 220)
        
        this.$emit('popperWidth', this.realPopperWidth)
      },
      // 更新`inputValue`
      _updateInputValue () {
        if (this.multiple) {
          // 多选
          this.inputValue = ''
        } else if (!this.filterable) {
          // 单选 + 非搜索
          this.inputValue = this.text || ''
        } else {
          // 单选 + 搜索
          if (this.isInputFocus) {
            this.inputValue = this.filter
          } else {
            this.inputValue = this.text || ''
          }
        }
      },
      // input blur
      _inputBlur () {
        this.isInputFocus = false
        this._emitBlur()
      },
      // input focus
      _inputFocus () {
        this.isInputFocus = true
        if (this.multiple) {
          // todo
          // this.$refs['multiple-filter-input'] && this.$refs['multiple-filter-input'].focus()
        }
        this._emitFocus()
      },
      // 多选搜索输入框的blur
      _multipleFilterInputBlur () {
        this.isMultipleFilterInputFocus = false
        this._emitBlur()
      },
      // 多选搜索输入框的focus
      _multipleFilterInputFocus () {
        this.isMultipleFilterInputFocus = true
        this._emitFocus()
      },
      // 清空
      _clear () {
        this.$emit('clear')
      },
      // toggle 收起展开下拉popper
      _toggleVisible (e) {
        this.$emit('toggle', e)
      },
      // 鼠标进入
      _mouseEnter () {
        this.showTags = true
      },
      // 鼠标离开
      _mouseLeave () {
        if (this.fixHeight) {
          this.showTags = false
        }
      },
      // 抛出focus事件
      _emitFocus () {
        this.$emit('focus')
      },
      // 抛出blur事件
      _emitBlur () {
        this.$emit('blur')
      },
      // 外部接口 - 更新高度
      updateHeight (isFirst) {
        // console.log('updateHeight')
        if (!this.multiple && !isFirst) return
        this.$nextTick(() => {
          const tags = this.$refs['tags']
          let inputChildNodes = this.$refs['input'].$el.childNodes
          let input = [].filter.call(inputChildNodes, item => item.tagName === 'INPUT')[0]
          // input的高度
          let computedHeight
          if (this.multiple) {
            computedHeight = !this.showTags && !this.visible
              ? this.height
              : Math.max(this.height, tags.clientHeight + 2) // 2是因为top为1px(对应底部也留1px)
          } else {
            computedHeight = this.height
          }
          input.style.height = `${computedHeight}px`
        })
      },
      // 外部接口 - 清空filter
      clearFilter () {
        this.filter = ''
      },
      // 外部接口 - focus 获取焦点
      focus () {
        if (this.multiple) {
          this.$refs['multiple-filter-input'].focus()
        }
      },
      // 外部接口 - 更新 popper, 也被组件内部使用, [慎用]性能损耗大，请确保只在需要时且popper被展开时才调用
      updatePopper () {
        if (!this.visible) return
        if (this.frozen) return
        // console.log('magic-input, exec updatePopper')
        this.$refs['popover'] && this.$refs['popover'].updatePopper()
      }
    }
  }
</script>

<style scoped lang="scss">
  .sy-magic-input {
    display: inline-block;
    position: relative;
    z-index: 100;
    width: 100%;
    &.hide{
      overflow: hidden;
      z-index: auto;
    }
    /*在fix-height模式下，hover会展开选中项，但高度不会变，所以存在被下面内容覆盖的情况，因此增加index*/
    &.fix-height.tags-expand{
      z-index: 101;
    }

    &.sy-magic-input--disabled{
      cursor: not-allowed;
    }
  }
  .sy-magic-input__wrap{
    width: 100%;
    position: relative;
    line-height: 0;
    &.sy-magic-input__wrap--fixed{
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .sy-magic-input__tags{
    position: absolute;
    right: 32px;
    left: 0;
    top: 1px;
    line-height: normal;
    white-space: normal;
    z-index: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .sy-magic-input__filter-input{
    flex-grow: 1;
    width: 1px;
    min-width: 37px;
    border: none;
    outline: none;
    padding: 0;
    margin-left: 10px;
    color: #666;
    font-size: 14px;
    appearance: none;
    background-color: transparent;

    &::-webkit-input-placeholder {
      color: #c0c4cc;
    }
    &:-moz-placeholder {
      color: #c0c4cc;
    }
    &::-moz-placeholder {
      color: #c0c4cc;
    }
    &::-ms-input-placeholder {
      color: #c0c4cc;
    }
  }
  .sy-magic-input__input {
    .el-input__icon {
      cursor: pointer;
      line-height: 32px;
    }
    /* todo remove 改成hover 展示后不再需要
    .el-icon-circle-close{
      margin-right: -5px;
    }
    */
  }
  .sy-magic-input--mini {
    .el-input__icon {
      line-height: 28px;
    }
  }
  .sy-magic-input__input--clear {
    .sy-magic-input__clear{
      display: none;
    }
    .sy-magic-input__expand{
      display: inline-block;
    }
    &:hover {
      .sy-magic-input__clear{
        display: inline-block;
      }
      .sy-magic-input__expand{
        display: none;
      }
    }
  }

  /*覆盖*/
  .sy-magic-input ::v-deep .el-tag {
    box-sizing: border-box;
    border-color: transparent;
    margin: 2px 0 2px 6px;
    background-color: #f0f2f5;
  }
  .sy-magic-input .sy-magic-input__input.el-input ::v-deep input{
    height: 100%;
    font-size: 14px;
  }
  /* todo remove 改成hover 展示后不再需要
  .sy-magic-input .sy-magic-input__input--clear ::v-deep input{
    padding-right: 50px;
  }
  */

  /* mini */
  .sy-magic-input--mini {
    .sy-magic-input__filter-input, .sy-magic-input__input.el-input ::v-deep .el-input__inner {
      font-size: 12px;
    }
  }
</style>
<style>
  /*会被挂载到body下*/
  .sy-magic-input__popper{
    padding: 0;
  }
</style>
